import kamala from '../../kamala'
import Portrait from './Portrait'

Portrait.install = function (Vue) {
  kamala(Vue)
  Vue.component(Portrait.name, Portrait)
}

export default Portrait
